@if (!csAgentTokenLoading) {
  <form (ngSubmit)="onSubmit()" [formGroup]="csAgentLoginForm">
    <label>
      <input aria-required="true" type="text" formControlName="userId" placeholder="Agent ID" />
      <cx-form-errors
        aria-live="assertive"
        aria-atomic="true"
        [control]="csAgentLoginForm.get('userId')"
      ></cx-form-errors>
    </label>

    <label>
      <input aria-required="true" type="password" placeholder="Password" formControlName="password" />
      <cx-form-errors
        aria-live="assertive"
        aria-atomic="true"
        [control]="csAgentLoginForm.get('password')"
      ></cx-form-errors>
    </label>
    <button type="submit">Sign In</button>
  </form>
} @else {
  <div class="spinner" aria-hidden="false" [attr.aria-label]="'common.loading'">
    <div></div>
    <div></div>
    <div></div>
  </div>
}
